import { ConnectionDto, ConnectionName } from "@arelia-types/connection"
import ConnectionCard from "./ConnectionCard";
import { useEffect, useState } from "react";
import MetaDialog from "../dialogs/MetaDialog";
import { Box } from "@mui/material";
import { fetchAccounts } from "../../../social/post/util";
import { PostForMeAccount } from "../../../social/post/models";

type Props = {
  connection: ConnectionDto,
}

export default function MetaConnection({ connection }: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const [postForMeAccounts, setPostForMeAccounts] = useState<PostForMeAccount[]>([]);

  const isInstagram = connection.name === ConnectionName.instagram;

  useEffect(() => {
    if (isInstagram) {
      fetchAccounts()
        .then(setPostForMeAccounts)
        .catch(e => console.error("Failed to fetch PostForMe accounts:", e));
    }
  }, [isInstagram, open]);

  const postForMeInstagramAccount = isInstagram
    ? postForMeAccounts.find(
        a => a.platform?.toLowerCase() === "instagram" &&
             (a.status ?? "").toLowerCase() === "connected"
      )
    : null;

  const isConnectedViaPostForMe = !!postForMeInstagramAccount;

  const connectionProps = isInstagram && isConnectedViaPostForMe && !connection.connected
    ? {
        ...connection,
        connected: true,
        status: "Connected",
        modeLabel: "Posting Only"
      }
    : connection;

  return <Box>
    <ConnectionCard {...connectionProps} onConnect={() => setOpen(true)} />
    {open && <MetaDialog
      connection={connection}
      onClose={() => setOpen(false)}
    >
    </MetaDialog>}
  </Box>;
}
